import { render, staticRenderFns } from "./ListaRecibosPorPaciente.vue?vue&type=template&id=33cc2599&scoped=true"
import script from "./ListaRecibosPorPaciente.vue?vue&type=script&lang=js"
export * from "./ListaRecibosPorPaciente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33cc2599",
  null
  
)

export default component.exports